import { render } from "./UpgradeMessageModal.vue?vue&type=template&id=f0281726&scoped=true"
import script from "./UpgradeMessageModal.vue?vue&type=script&lang=js"
export * from "./UpgradeMessageModal.vue?vue&type=script&lang=js"

import "./UpgradeMessageModal.vue?vue&type=style&index=0&id=f0281726&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0281726"]])

export default __exports__